import { MouseEventHandler, useEffect, useState } from 'react';

import { toggleTips } from '../../db/app/actions';
import { selectTipsPrefs } from '../../db/app/selectors';
import { useAppSelector } from '../../store/hooks';
import { useRequestDispatch } from '../../utils/request-actions';

const useHelpTipsVM = () => {
  const requestDispatch = useRequestDispatch();

  const { turnOff } = useAppSelector((state) => selectTipsPrefs(state));

  const [isTogglingHelpTips, setIsTogglingHelpTips] = useState(false);
  const [areHelpTipsOn, setAreHelpTipsOn] = useState(!turnOff);

  const handleToggleHelpTips: MouseEventHandler<HTMLInputElement> = async (event) => {
    try {
      setIsTogglingHelpTips(true);
      await requestDispatch(toggleTips, areHelpTipsOn);
      // without using setState callback to keep it in sync with API layer.
      // callback won't be needed here because this operation is async.
      setAreHelpTipsOn(!areHelpTipsOn);
    } finally {
      setIsTogglingHelpTips(false);
    }
  };

  useEffect(
    function setInitialValues() {
      setAreHelpTipsOn(!turnOff);
    },
    [turnOff]
  );

  return { isTogglingHelpTips, areHelpTipsOn, handleToggleHelpTips };
};

export default useHelpTipsVM;
